<template>
  <div id="tags-view-container" class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper">
      <div id="scrollWrapper" class="tags-view-wrapper">
        <router-link
          v-for="tag in visitedViews"
          ref="tag"
          :key="tag.path"
          :class="[{ active : isActive(tag) }, 'tags-view-item']"
          :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
          tag="span">
          <span>{{ tag.title }}</span>
          <close-icon :tag="tag" @close="closeSelectedTag"/>
        </router-link>
      </div>
      <div id="contextWrapper" v-if="visitedViews && visitedViews.length > 0" @click="openMenu" class="contextWrapper">
        <img src="@/assets/xiala.png"/>
      </div>
    </scroll-pane>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu" id="contextmenu">
      <li @click="closeAllTags(selectedTag)">关闭全部</li>
      <li @click="closeOthersTags">关闭其他页</li>
      <li v-if="!(selectedTag.meta&&selectedTag.meta.affix)" @click="closeSelectedTag(selectedTag)">关闭当前页</li>
      <li @click="refreshSelectedTag(selectedTag)">刷新当前页</li>
    </ul>
  </div>
</template>

<script>
import Sortable from 'sortablejs';
import path from 'path';
import CloseIcon from './CloseIcon';
import ScrollPane from './ScrollPane';
import { constantRoutes } from '@/router';

export default {
  components: { CloseIcon, ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: [],
      isMouseEnter: false,
    };
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    },
    routes() {
      return constantRoutes;
    },
  },
  watch: {
    $route() {
      this.addTags();
      this.moveToCurrentTag();
    },
    visible(value) {
      if (!value) {
        document.body.removeEventListener('click', this.closeMenu);
      }
    },
  },
  mounted() {
    this.initTags();
    this.addTags();
    this.setSort();
  },
  methods: {
    setSort() {
      const el = document.getElementById('scrollWrapper');
      this.sortable = Sortable.create(el, {
        direction: 'horizontal',
      });
    },
    isActive(route) {
      return route.path === this.$route.path;
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = [];
      routes.forEach((route) => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path);
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta },
          });
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path);
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags];
          }
        }
      });
      return tags;
    },
    initTags() {
      this.affixTags = this.filterAffixTags(this.routes);
      const { affixTags } = this;
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag);
        }
      }
    },
    addTags() {
      const { name } = this.$route;
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route);
      }
      return false;
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag;
      this.$nextTick(() => {
        if (tags && tags.length > 0) {
          for (const tag of tags) {
            if (tag.to.path === this.$route.path) {
              this.$refs.scrollPane.moveToTarget(tag);
              // when query is different then update
              if (tag.to.fullPath !== this.$route.fullPath) {
                this.$store.dispatch('tagsView/updateVisitedView', this.$route);
              }
              break;
            }
          }
        }
      });
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view;
        this.$nextTick(() => {
          this.$router.replace({
            path: `/redirect${fullPath}`,
          });
        });
      });
    },
    closeSelectedTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view);
        }
      });
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag);
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag();
      });
    },
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return;
        }
        this.toLastView(visitedViews, view);
      });
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView);
      } else if (view.name === 'Homepage') {
        this.$router.replace({ path: `/redirect${view.fullPath}` });
      } else {
        this.$router.push('/');
      }
    },
    openMenu() {
      const contextWrapper = document.getElementById('contextWrapper');
      const react = contextWrapper.getBoundingClientRect();
      const {
        left,
        top,
        width,
        height
      } = react;
      this.top = top + height;
      this.left = left + width / 2;
      if (this.visible === false) {
        setTimeout(() => {
          document.body.addEventListener('click', this.closeMenu);
        });
      }
      this.visible = true;
      const { name } = this.$route;
      for (const row of this.visitedViews) {
        if (row.name === name) {
          this.selectedTag = row;
          break;
        }
      }
    },
    closeMenu() {
      this.visible = false;
    },
    handleMouseEnter(index, router) {
      router.isMouseEnter = true;
      this.isMouseEnter = true;
      this.$store.dispatch('tagsView/updateVisitedView', router);
    },
    handleMouseLeave(index, router) {
      router.isMouseEnter = false;
      this.isMouseEnter = false;
      this.$store.dispatch('tagsView/updateVisitedView', router);
    },
  },
};
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 36px;
  width: 100%;
  background: #E2E2E2;
  .tags-view-wrapper {
    display: inline-block;
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      color: #555555;
      height: 36px;
      line-height: 36px;
      background: #CECECE;
      padding: 0 6px;
      font-size: 14px;
      margin: 0 1px;
      span {
        margin: 0 5px;
      }
      &.active {
        background: #169BD5;
        color: #fff;
      }
      &:first-of-type {
        margin-left: 0;
      }
    }
  }
  .contextWrapper {
    display: inline-block;
    position: relative;
    cursor: pointer;
    height: 36px;
    line-height: 36px;
    color: #555555;
    background: #CECECE;
    font-size: 14px;
    margin-left: 2px;
  }
}
</style>

<style lang="scss">
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 2px rgba(0, 0, 0, .3);
  li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;
    &:hover {
      background: #169BD5;
      color: white;
    }
  }
}
</style>
